/**
 * Represents a technology gallery.
 * @author Leonard Breitkopf <leonard@iconum.com>
 * @class TechGallery
 * @param {number} id - The technology id.
 * @param {object} options - The render options for the gallery.
 */
function TechGallery(id, options) {
    /**
     * A reference to the current gallery instance.
     * @type {TechGallery}
     * @private
     */
    var self = this,
        dimensions;

    // Objects
    var $slides = $('.tech-slide[data-id="' + id + '"]'),
        $overlay = $(__getOption('selectors.backgroundOverlay', true) + ',' + __getOption('selectors.touchOverlay', true)),
        $outer = $(__getOption('selectors.outerHost')),
        $window = $(window),
        $balls = __getOption('selectors.indexHost', true),
        balls = [];
    self.__particles = [];
    self.__lastY = 0;
    self.__currentSlide = {};
    self.__open = false;

    // State
    var currentSlide = 1,
        current$slide,
        maxCount = -1,
        startX,
        startY,
        lastY,
        distX,
        distY,
        elapsedTime,
        startTime;

    /*
        Start-up
        =========================
    */
    if ($slides.length === 0)
        return console.error('No slides are selected for id: ' + id);

    dimensions = {
        width: $window.width(),
        height: $window.height()
    };
    maxCount = $slides.length;

    $slides.each(function () {
        var $this = $(this);
        var slide = parseInt($this.data('count'));

        self.__particles[slide] = $this.find(__getOption('selectors.particle'));

        var $ball = __getOption('creators.indexBullet')(slide);
        if (slide === 1)
            $ball.addClass('active');
        balls.push($ball);
        $balls.append($ball);
    });
    $balls.css({
        marginLeft: -($balls.width() / 2)
    });

    recalculate();

    /*
        Events
        =========================
    */
    __getOption('selectors.openClick', true).click(function (e) {
        if (self.__open)
            return;

        if (e.target.className != 'close-slide')
            self.open();
    });


    $overlay.click(function (e) {
        if (!self.__open)
            return;

        if ($(e.target).is(__getOption('selectors.touchOverlay', true)))
            if (propagateParticleClick({
                x: e.pageX,
                y: e.pageY
            }))
                return;

        self.close();
    });

    $(__getOption('selectors.arrow')).click(function (e) {
        if (!self.__open)
            return;

        if ($(e.target).is('.left'))
            self.previous();
        else if ($(e.target).is('.right'))
            self.next();
    });

    $(__getOption('selectors.touchOverlay', true))[0].addEventListener('touchstart', function (e) {
        if (!self.__open)
            return;

        dist = 0;
        startX = e.changedTouches[0].pageX;
        startY = self.__lastY = parseInt(e.changedTouches[0].pageY);

        startTime = new Date().getTime();
    }, false);


    $(__getOption('selectors.touchOverlay', true))[0].addEventListener('touchmove', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (isNaN(self.__lastY) || self.__lastY === 0) self.__lastY = parseInt(e.changedTouches[0].pageY);

        var deltaY = self.__lastY - parseInt(e.changedTouches[0].pageY);
        self.__lastY = parseInt(e.changedTouches[0].pageY);

        var $wrapper = $('[data-id="' + id + '"][data-count="' + currentSlide + '"] ' + __getOption('selectors.scrollWrapper'));
        var $inner = $wrapper.children().first();

        var excess = 0;
        self.__currentSlide.children().not(__getOption('selectors.scrollWrapper')).each(function (i, e) {
            excess += $(this).height();
        });

        if ($inner.height() <= (self.__currentSlide.height() - excess))
            return;

        var currDelta = parseInt($inner.data('scrollDelta'));
        if (isNaN(currDelta)) currDelta = 0;
        currDelta += deltaY;

        var maxScroll = $inner.height() - $wrapper.height();
        if (maxScroll <= 0)
            return;

        if (currDelta > maxScroll)
            currDelta = maxScroll;
        else if (currDelta < 0)
            currDelta = 0;

        $inner.css({
            transform: 'translateY(' + (-1 * currDelta) + 'px)'
        });
        $inner.data('scrollDelta', currDelta);
    }, true);

    $(__getOption('selectors.touchOverlay', true))[0].addEventListener('touchend', function (e) {
        if (!self.__open)
            return;

        distX = e.changedTouches[0].pageX - startX;
        distY = e.changedTouches[0].pageY - startY;

        elapsedTime = new Date().getTime() - startTime;

        if (elapsedTime <= options.touch.allowedTime)
            if (Math.abs(distX) >= options.touch.threshold && Math.abs(distY) <= options.touch.restraint)
                if (distX < 0)
                    self.next();
                else
                    self.previous();
    }, false);

    $(document).keydown(function (e) {
        if (!self.__open)
            return;

        var left = e.keyCode === 37;
        var right = e.keyCode === 39;
        var escape = e.keyCode === 27;

        if (left)
            self.previous();
        if (right)
            self.next();
        if (escape)
            self.close();
    });

    document.onfullscreenchange = function () {
        var state = document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled;

        console.log('Fullscreen state: ' + (state ? 'opened' : 'closed'));

        var exit = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen;
        if (!state)
            exit();
    };

    $window.resize(function () {
        dimensions = {
            width: $window.width(),
            height: $window.height()
        };
        recalculate();
    });

    /*
        Functions
        =========================
    */
    function skew(option, positive) {
        if (positive)
            return 'skew(' + option.x + 'deg, ' + option.y + 'deg) ';
        else
            return 'skew(' + (-1 * option.x) + 'deg, ' + (-1 * option.y) + 'deg) ';
    }

    function rotate(option, positive) {
        return 'rotate3d(' +
                (options.rotate.x ? 1 : 0) + ', ' +
                (options.rotate.y ? 1 : 0) + ', ' +
                (options.rotate.z ? 1 : 0) + ', ' +
                ((positive ? 1 : -1) * options.rotate.degree) + 'deg) ';
    }

    function recalculate() {
        $balls.children().removeClass('active');

        $slides.each(function (i, e) {
            var $element = $(e);
            var count = $element.data('count');

            if (count < currentSlide)
                setCSS($element, TechGallery.SLIDESTATE.LEFT);
            else if (count == currentSlide) {
                self.__currentSlide = $element;
                __getOption('selectors.findBall')($balls, count)
                    .addClass('active');
                setCSS($element, TechGallery.SLIDESTATE.OPEN);
            } else if (count > currentSlide)
                setCSS($element, TechGallery.SLIDESTATE.RIGHT);
        });
    }

    function setCSS($element, state) {
        var transform = '';

        if (state === TechGallery.SLIDESTATE.LEFT) {
            transform += 'translateX(-' + (dimensions.width + 1050) / 2 + 'px) ';
            transform += 'translateY(50px) ';

            if (options.enableSkew)
                transform += skew(options.skew, true);
            if (options.enableRotate)
                transform += rotate(options.rotate, true);
        } else if (state === TechGallery.SLIDESTATE.OPEN) {
            transform = 'translate(0px) '
        } else if (state === TechGallery.SLIDESTATE.RIGHT) {
            transform += 'translateX(' + (dimensions.width + 1050) / 2 + 'px) ';
            transform += 'translateY(50px) ';

            if (options.enableSkew)
                transform += skew(options.skew);
            if (options.enableRotate)
                transform += rotate(options.rotate);
        }

        $element.css({
            transform: transform
        }).find(__getOption('selectors.scrollWrapper') + ' > *')
            .css({
                transform: 'translateY(0px)'
            });
    }

    function propagateParticleClick(point) {
        var _p = self.__particles[currentSlide];

        if (_p === undefined || !_p.length)
            return false;

        var preventProp = false;

        _p.each(function (i, e) {
            var $this = $(this);

            if (isWithinParticleBounds($this.children(), point)) {
                if ($this.is('.video'))
                    handleVideo($this.find('iframe')[0], point);
                preventProp = true;
            }
        });

        return preventProp;
    }

    function isWithinParticleBounds($element, point) {
        var posX = $element.offset().left;
        var posY = $element.offset().top;

        if (point.x >= posX && point.y >= posY)
            if (point.x <= (posX + $element.width()) && point.y <= (posY + $element.height()))
                return true;

        return false;
    }

    function isWithinFullscreenBounds(iframe, point) {
        if (!options.youtube.fullscreenEnabled)
            return false;

        var $iframe = $(iframe);
        var posX = $iframe.offset().left + ($iframe.width() - options.youtube.fullscreenWidth);
        var posY = $iframe.offset().top + ($iframe.height() - options.youtube.fullscreenHeight);

        if (point.x >= posX && point.y >= posY)
            if (point.x <= (posX + options.youtube.fullscreenWidth) && point.y <= (posY + options.youtube.fullscreenHeight))
                return true;

        return false;
    }

    function sendYoutubeCommand(frame, command, args) {
        frame.contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: command,
                args: args || [],
                id: frame.id || ''
            }), '*'
        );
    }

    function handleVideo(iframe, point) {
        if (isWithinFullscreenBounds(iframe, point)) {
            var requestFullScreen = iframe.requestFullScreen
                || iframe.mozRequestFullScreen
                || iframe.webkitRequestFullScreen;
            if (requestFullScreen)
                requestFullScreen.bind($(iframe).parent()[0])();
            sendYoutubeCommand(iframe, 'playVideo');
            $(iframe).parent().data('playing', true);
        } else
            if (!$(iframe).parent().data('playing')) {
                sendYoutubeCommand(iframe, 'playVideo');
                $(iframe).parent().data('playing', true);
            } else {
                sendYoutubeCommand(iframe, 'pauseVideo');
                $(iframe).parent().data('playing', false);
            }
    }

    function __getOption(optionSelector, requireFunction) {
        return TechGallery.__getOption(optionSelector, options,
            self.__extracted == undefined ? { __extracted: __extracted } : self, requireFunction);
    }

    function __extracted() {
        return {
            id: id,
            $elements: $slides,
            $host: $outer
        };
    }

    /**
     * Opens the gallery.
     * @param {number} slide The slide to show after open. Optional.
     */
    self.open = function (slide) {
        console.log('Called open()');
        console.log(new Error().stack);

        if (self.__open)
            return;

        if (slide) {
            currentSlide = slide;
            recalculate();
        }

        self.__open = true;

        $overlay
            .add($slides)
            .add($balls)
            .show();

        console.log($._data($(".close-slide")[0], "events"));
    };

    /**
     * Closes the gallery and resets current position.
     */
    self.close = function () {
        console.log('Called close()');
        console.log(new Error().stack);

        if (!self.__open)
            return;

        currentSlide = 1;
        self.__open = false;

        $.each(self.__particles, function () {
            var $videos = $(this).filter('.video');
            if ($videos.length)
                $videos.each(function () {
                    $(this).data('playing', false);
                    var iframe = $(this).find('iframe')[0];
                    iframe.src = iframe.src;
                });
        });

        $overlay
            .add($slides)
            .add($balls)
            .hide();

        recalculate();
    };

    /**
     * Goes to the next slide.
     */
    self.next = function () {
        if (!self.__open)
            return;

        if (currentSlide < maxCount) {
            $.each(self.__particles[currentSlide], function () {
                if ($(this).is('.video') && $(this).data('playing'))
                    sendYoutubeCommand($(this).find('iframe')[0], 'pauseVideo');
            });

            current$slide =
            currentSlide++;
            recalculate();
        }
    };

    /**
     * Goes to the previous slide.
     */
    self.previous = function () {
        if (!self.__open)
            return;

        if (currentSlide > 1) {
            $.each(self.__particles[currentSlide], function () {
                if ($(this).is('.video'))
                    sendYoutubeCommand($(this).find('iframe')[0], 'pauseVideo');
            });

            currentSlide--;
            recalculate();
        }
    };

    /**
     * Sets the current options and re-renders
     * @param {object} opt The options used to render this gallery.
     */
    self.set = function (opt) {
        options = $.extend(TechGallery.DEFAULTS, opt);
        recalculate();
    }

    self.__extracted = __extracted;
    console.log($._data($(".close-slide")[0], "events"));
}

/*
    Statics
    =========================
*/

/**
 * Sets up all tech galleries found on this page.
 * @static
 * @param {object} options The options to use for all galleries. [Option]al ;)
 * @returns {Array} The galleries found on the page.
 */
TechGallery.setup = function (options) {
    window.galleries = [];
    options = $.extend(TechGallery.DEFAULTS, options);

    $.each(TechGallery.__getOption('selectors.gallery', options)(), function (i, e) {
        window.galleries.push(new TechGallery(TechGallery.__getOption('selectors.slideId', options, {
            __extracted: function () {
                return {
                    $elements: TechGallery.__getOption('selectors.gallerySlides', options)(e)
                };
            }
        }, true), options));
    });
    return window.galleries;
};

/**
 * Gets a selector option.
 * @static
 * @private
 * @param {String} option The selector to select the option.
 * @param {Object} options The options object.
 * @param {TechGallery} instance The TechGallery instance.
 * @param {Boolean} requireFunction Set's whether this option is required to return a jQuery object.
 * @returns {$Object|String} The result of the query.
 */
TechGallery.__getOption = function (option, options, instance, requireFunction) {
    var _option;
    try {
        _option = option.startsWith('options') ? eval(option) : eval('options.' + option);
    } catch (e) {
        throw Error('Option selector "' + option + '" yielded no result.');
    }

    if (_option && $.isFunction(_option) && requireFunction) {
        if (instance === null || instance === undefined)
            return _option();

        var extracted = instance.__extracted;
        if (extracted != undefined)
            extracted = extracted();
        else
            extracted = {};

        return _option(extracted.id, extracted.$elements, extracted.$host);
    }

    if (requireFunction)
        throw Error('The option is expected to return a jQuery object. It needs to be a function.');

    return _option;
};

/**
 * The default options for the rendering of the gallery.
 * @readonly
 * @constant {object}
 */
TechGallery.DEFAULTS = {
    enableSkew: true,
    enableRotate: false,
    selectors: {
        gallery: function () {
            var galleryIds = [];

            $('[data-tech-id]').each(function (i, e) {
                if (!(function (id) {
                    for (var i in galleryIds)
                        if (galleryIds[i] == id)
                        return true;
                    return false;
                })($(e).data('techId')))
                    galleryIds.push($(e).data('techId'));
            });

            return galleryIds;
        },
        gallerySlides: function (id) {
            return $('.tech-slide[data-id="' + id + '"]');
        },
        slideId: function (id, $elements, $host) {
            return $elements.data('id')
        },
        indexHost: function (id, $elements, $host) {
            return $('[data-tech-id="' + id + '"] .tech-balls');
        },
        scrollWrapper: '.scroll-wrap',
        particle: '.tech-particle',
        outerHost: '.technology-summary',
        touchOverlay: function (id) { return '[data-tech-id="' + id + '"] > .touch-overlay' },
        backgroundOverlay: function (id) { return '[data-tech-id="' + id + '"] .tech-overlay, [data-tech-id="' + id + '"] .close-slide' },
        arrow: '.tech-arrow',
        openClick: function (id, $elements, $host) {
            return $('[data-tech-id="' + id + '"]');
        },
        findBall: function ($indexHost, slide) {
            return $indexHost.find('[data-slide="' + slide + '"]');
        }
    },
    creators: {
        indexBullet: function (idx) {
            return $('<li data-slide="' + idx + '" class="tech-ball"></li>');
        }
    },
    skew: {
        x: 5,
        y: -5
    },
    rotate: {
        x: false,
        y: true,
        z: false,
        degree: 100
    },
    touch: {
        threshold: 75,
        restraint: 100,
        allowedTime: 300,
    },
    youtube: {
        /**
         * Not fully implemented. Please keep disabled.
         *
         *            /\
         *           /  \
         *          /    \
         *         /  __  \
         *        /  |  |  \
         *       /   |  |   \
         *      /    |__|    \
         *     /      __      \
         *    /      |__|      \
         *   /__________________\
         */
        fullscreenEnabled: false,
        fullscreenWidth: 55,
        fullscreenHeight: 35
    }
};

/**
 * The state of slide in a gallery.
 * @readonly
 * @enum {number}
 */
TechGallery.SLIDESTATE = {
    /**
    * Represents the shown state
    */
    OPEN: 1,
    /**
     * The slide is hidden on the left side of the screen
     */
    LEFT: 2,
    /**
     * The slide is hidden on the right side of the screen
     */
    RIGHT: 3
};